/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPage } from '../features/filter/filterTransactions';

function Pagination() {
    const { page } = useSelector((state) => state.filter);
    const { transactions } = useSelector((state) => state.transaction);

    const dispatch = useDispatch();

    const limit = 10;
    const pages = Math.ceil(transactions.length / limit);

    const content = [];

    const handlePage = (page) => {
        dispatch(setPage(page));
    };

    for (let i = 1; i <= pages; i++) {
        content.push(
            <div
                onClick={() => handlePage(i)}
                className={`${
                    page === i &&
                    'flex items-center px-4 py-2 text-gray-500 bg-gray-300 rounded-md m-6'
                } pagination_item m-6`}
            >
                {i}
            </div>
        );
    }

    return (
        <div className="pagination ">
            <button type="button" className="flex items-center space-x-1">
                {content}
            </button>
        </div>
    );
}

export default Pagination;
